module.exports = __webpack_public_path__ + "img/video-thumb.a85c2ca6.png";